import axiosInstance from '../utils/axios';
import amplifyConfig from '../config';
import API_PATH from './endpoints';
import type { AxiosResponse } from 'axios';
import type { BusinessType, Language, SteelCategory, SteelMaker, SteelType } from '../types/common';
import type { GetCustomerParams, OptionsType } from '../types/options';

const optionsAPI = {
  /**
   * 組織名の取得
   * @return OptionsType[]
   */
  getOrganizationBaseOptions(): Promise<AxiosResponse<OptionsType[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.ORGANIZATION_BASE);
  },

  /**
   * 鉄鋼メーカーの取得
   * @return OptionsType[]
   */
  getSteelMakerOptions(): Promise<AxiosResponse<OptionsType<SteelMaker>[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.STEEL_MAKER);
  },

  /**
   * 区分の取得
   * @return OptionsType[]
   */
  getBusinessTypeOptions(): Promise<AxiosResponse<OptionsType<BusinessType>[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.BUSINESS_TYPE);
  },

  /**
   * 分類の取得
   * @return OptionsType[]
   */
  getSteelCategoryOptions(): Promise<AxiosResponse<OptionsType<SteelCategory>[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.STEEL_CATEGORY);
  },

  /**
   * 分類＋品種の取得
   * @return OptionsType[]
   */
  getSteelCategoryTypeOptions(): Promise<AxiosResponse<OptionsType<SteelCategory>[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.STEEL_CATEGORY_TYPE);
  },

  /**
   * 需要家の取得
   * @return OptionsType[]
   */
  getCustomerOptions(params: GetCustomerParams): Promise<AxiosResponse<OptionsType[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.CUSTOMER + '/' + String(params));
  },

  /**
   * 需要家1の取得
   * @return OptionsType[]
   */
  getCustomer1Options(): Promise<AxiosResponse<OptionsType[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.CUSTOMER1);
  },

  /**
   * 需要家2の取得
   * @return OptionsType[]
   */
  getCustomer2Options(): Promise<AxiosResponse<OptionsType[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.CUSTOMER2);
  },

  /**
   * 需要家3の取得
   * @return OptionsType[]
   */
  getCustomer3Options(): Promise<AxiosResponse<OptionsType[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.CUSTOMER3);
  },

  /**
   * 言語の取得
   * @return OptionsType[]
   */
  getLanguageOptions(): Promise<AxiosResponse<OptionsType<Language>[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.LANGUAGE);
  },

  /**
   * 商社の取得
   * @return OptionsType[]
   */
  getTradingCompanyOptions(): Promise<AxiosResponse<OptionsType[]>> {
    return axiosInstance.get(amplifyConfig.apiGateway.URL + API_PATH.OPTIONS.TRADING_COMPANY);
  },
};

export default optionsAPI;
